import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const StyledFlexColumnsWrapper = styled.main`
  width: 100%;

  > strong {
    color: #333;
    font-weight: 700;
    font-size: 24px;
    line-height: 34.75px;
  }

  table {
    tr[data-highlight='deactivated' i] {
      td {
        background-color: #fafafa;
        color: #999999;
      }
    }

    td > u {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      :hover {
        color: #7fe200;
      }
      b {
        color: #7fe200;
      }
      & > div {
        margin-left: 6px;
        background-color: #ffffff;
      }
      &:hover > div {
        border-color: #7fe200;
        background-color: #effdda;
        :before,
        :after {
          border-color: #7fe200;
        }
      }
      &:active > div {
        border-color: #7fe200;
        background-color: #7fe200;
        :before,
        :after {
          border-color: #ffffff;
        }
      }
    }
  }

  & section {
  }
`;

export const StyledSendingWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledArrow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  flex-wrap: wrap;
  margin: 0 40px;
  width: 40px;
  /* height: 100%; */

  & .arrowRight {
    margin-bottom: 16px;
  }

  & img {
  }

  & img:hover {
    cursor: pointer;
  }
`;

export const RightButtonSection = styled.section`
  display: flex;
  flex-direction: row;
  position: absolute;
  left: 1320px;
  bottom: -68px;
`;

export const BackButtonStyle = css`
  width: 124px;
  border-color: #999999;
  color: #999999;
  margin: 0 5px;
  :hover {
    background-color: rgba(153, 153, 153, 0.2);
  }
  :active {
    background: #999999;
  }
`;
export const SubmitButtonStyle = css`
  width: 145px;
  margin: 0 5px;
`;
